export class ResponseError extends Error {
  constructor(
    readonly response: string,
    readonly url: string,
    readonly method: string,
    readonly statusCode: number,
  ) {
    super(`${method} ${url} - ${statusCode}\n\n${response}`);
  }
}
